import { useWallet, WalletStatus } from "@terra-money/wallet-provider";
import WindowDimensions from "hooks/useDimensions";
import { useChainAddress } from "state/global";
import ConnectButton from "./ConnectButton";
import ConnectedButton from "./ConnectedButton";
import InitializingButton from "./InitializingButton";

const WalletButton = () => {
    const { status } = useWallet();
    const [eth_address] = useChainAddress("address");
    const [network] = useChainAddress("network");
    const isWeb = WindowDimensions();

    if (status === WalletStatus.INITIALIZING)
        return <InitializingButton/>
    else if (status === WalletStatus.WALLET_CONNECTED)
        return <ConnectedButton/>
    else if (status === WalletStatus.WALLET_NOT_CONNECTED && eth_address !== "" && network !== "") {
        return <>{isWeb && <ConnectedButton/>}</>
    }
    else
        return <ConnectButton/>
}

export default WalletButton;